import "./MoreInformation.css";
import vestingCliffImage from "../../img/vestingCliff.png";

export const VestingCliff = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column">
      <text className="sub-title">Cliff</text>
      <text className="paragraph">
        A cliff in a vesting schedule means that before the cliff, no shares
        will vest. Once the cliff has been reached, all the shares that would
        have vested during the cliff period according to the frequency will vest
        all at once.
      </text>
      <text className="paragraph">
        For example, if the founders agree on a 4-year vesting schedule with
        monthly vesting and a 1-year cliff, then the founders would not vest any
        equity until the first year has passed. At that point, the founders
        would vest 25% of their shares. From that point forward, the vesting
        would continue according to the vesting schedule, i.e. with monthly
        vesting.
      </text>
      <text className="paragraph">
        The cliff serves as a way of protecting the company for early leaving
        founders.
      </text>
    </div>
    <div className="info-column small flex">
      <img src={vestingCliffImage} className="info-image" />
    </div>
  </div>
);
